export default function flattenMessages(nestedMessages, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const newMessages = { ...messages }
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      newMessages[prefixedKey] = value
    } else {
      Object.assign(newMessages, flattenMessages(value, prefixedKey))
    }

    return newMessages
  }, {})
}
